import { useAuth } from "../../../context/Auth";
import { DeleteIcon } from "../../../icons/Icon";
import prodStyles from "./ProdLineInfoCard.module.css";

const ProdLineInfoCard = ({
  lineName = "",
  pLId = "",
  modelNo = "",
  lineStatus = "",
  // manufacturer = [],
  subText = "",
  capacity,
  workingHrs,
  imageUri,
  showStatus = true,
  showManufacturer = true,
  showSubText = true,
  showFooter = true,
  onClick,
  warehouse,
  warehouseId,
  deleteIconTime,
  onDelete,
}) => {
  const { mode } = useAuth();

  const STATUS_MAP = {
    running: {
      label: "Running",
      dot: "#f5b846",
      lightBg: "#fff8e6",
      darkBg: "#32291E",
      lightColor: "#b07d10",
      darkColor: "#f5b846",
    },

    idle: {
      label: "Idle",
      dot: "#f0a500",
      lightBg: "#fff8e6",
      darkBg: "#32291E",
      lightColor: "#b07d10",
      darkColor: "#f0a500",
    },

    maintenance: {
      label: "Maintenance",
      dot: "#416AB3",
      lightBg: "#eef4ff",
      darkBg: "#202632",
      lightColor: "#416AB3",
      darkColor: "#416AB3",
    },

    stopped: {
      label: "Stopped",
      dot: "#db0707",
      lightBg: "#fdeaea",
      darkBg: "#312024",
      lightColor: "#db0707",
      darkColor: "#db0707",
    },
  };

  const statusConfig = STATUS_MAP[lineStatus?.toLowerCase()] || null;

  // Show delete icon only if created within the last 24 hours
  const canDelete = (() => {
    if (!deleteIconTime) return false;
    const createdTime = new Date(deleteIconTime).getTime();
    if (Number.isNaN(createdTime)) return false;
    const hoursSinceCreated = (Date.now() - createdTime) / (1000 * 60 * 60);
    return hoursSinceCreated < 24;
  })();

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete?.();
  };

  return (
    <div
      style={{ position: "relative" }}
      className={`${prodStyles.card} ${mode ? prodStyles.card_dark : ""}`}
      onClick={onClick}
    >
      {/* ── Top: avatar + text ────────────────────────────── */}
      <div className={prodStyles.top}>
        {/* Avatar */}
        <div className={prodStyles.avatar}>
          {imageUri ? (
            <img
              src={`${process.env.REACT_APP_S3URL}${imageUri}`}
              alt={lineName}
              className={prodStyles.avatarImg}
            />
          ) : (
            <span
              className={`${prodStyles.avatarInitial} ${mode ? prodStyles.avatarInitial_dark : ""}`}
            >
              {lineName.charAt(0).toUpperCase()}
            </span>
          )}
        </div>

        {/* Text */}
        <div className={prodStyles.textBlock}>
          <div className={prodStyles.nameRow}>
            <p
              className={`${prodStyles.lineName} ${mode ? prodStyles.lineName_dark : ""}`}
            >
              {lineName}
            </p>
          </div>
          <div>
            {showStatus && statusConfig && (
              <span
                className={prodStyles.statusPill}
                style={{
                  backgroundColor: mode
                    ? statusConfig.darkBg
                    : statusConfig.lightBg,
                  color: mode
                    ? statusConfig.darkColor
                    : statusConfig.lightColor,
                }}
              >
                <span
                  className={prodStyles.pillDot}
                  style={{ backgroundColor: statusConfig.dot }}
                />
                {statusConfig.label}
              </span>
            )}
          </div>

          {showSubText && subText && (
            <p
              className={`${prodStyles.subText} ${mode ? prodStyles.subText_dark : ""}`}
            >
              {subText}
            </p>
          )}

          {pLId && (
            <p
              className={`${prodStyles.subText} ${mode ? prodStyles.subText_dark : ""}`}
            >
              Line Id : {pLId}
            </p>
          )}

          {warehouse && (
            <p
              className={`${prodStyles.subText} ${mode ? prodStyles.subText_dark : ""}`}
            >
              {warehouse}
            </p>
          )}
        </div>
      </div>

      {/* ── Footer: capacity + hours chips ───────────────── */}
      {showFooter && (capacity !== undefined || workingHrs !== undefined) && (
        <div
          className={`${prodStyles.footer} ${mode ? prodStyles.footer_dark : ""}`}
        >
          {capacity !== undefined && (
            <span
              className={`${prodStyles.chip} ${mode ? prodStyles.chip_dark : ""}`}
            >
              {capacity.toLocaleString()} pcs/day
            </span>
          )}
          {workingHrs !== undefined && (
            <span
              className={`${prodStyles.chip} ${mode ? prodStyles.chip_dark : ""}`}
            >
              {workingHrs} hrs/day
            </span>
          )}
        </div>
      )}

      {canDelete && (
        <div
          onClick={handleDeleteClick}
          style={{
            position: "absolute",
            right: 10,
            top: 10,
            height: 35,
            width: 35,
            borderRadius: "50%",
            background: mode ? "#232529" : "#fdeaea",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <div>
            <DeleteIcon />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProdLineInfoCard;
